import React, { useEffect, useState } from 'react';

import { Loader } from '@nord/ui';

import './index.scss';

/**
 *
 * @param rest
 * @constructor
 * @deprecated use NewLoader
 */
const LoaderComp: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...rest }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 200);

    return () => {
      clearTimeout(timer);
    };
  });

  return (
    visible && (
      <span className="Loader" data-testid="loader">
        <Loader size="small" {...rest} />
      </span>
    )
  );
};

export default LoaderComp;
